
import React, { Component } from 'react';
import './assign-coordinator.scss'
import { Modal, ModalBody } from "reactstrap";

import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown';
// import CommonApi from '../../../apis/common'
import { ImageConstants, } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'

class AssignCoordinator extends Component {
    constructor(props) {
        super(props)

    }



    state = {
        existingUsers: [],
        types: [],
        title: "ASSIGN COORDINATOR",
        selectedUser: null,
        existingUsersDropdown: []
    }

    userHash = {}

    componentDidMount() {
        this.getStaffs()
    }


    getStaffs(payload = {}) {
        payload.types = `nin/COORDINATOR`
        SchoolApi.getStaffs(payload)
            .then(response => {
                let items = [];
                this.userHash = {}
                for (let i = 0; i < response?.response?.length; i++) {
                    items.push({
                        title: response?.response[i].firstName,
                        value: response?.response[i]._id,
                    })
                    this.userHash[response?.response[i]._id] = response?.response[i]
                }

                this.setState({ existingUsersDropdown: items })
            }).catch(err => {
            })

    }

    onSave() {
        if (!this.state.selectedUser || this.state.isSubmit == true) return

        let user = this.userHash[this.state.selectedUser]
        if (!user?.types || !user.types.length) user.types = []

        let payload = {
            _id: user?._id,
            types: [...user.types, { type: "COORDINATOR", displayType: "Coordinator" }],
        }

        this.setState({ isSubmit: true })

        SchoolApi.updateStaff(payload).then(response => {
            this.props.onClose()
            this.setState({ isSubmit: false })
        }).catch(err => {
            this.setState({ isSubmit: false })
        })
    }

    validatePayload(payload) {

        return true
    }

    addNewContact = () => {
        this.props.delegate && this.props.showAddcontact && this.props.showAddcontact({}, 'CREATE');
    }

    onSelectUser = (option) => {
        if (option) {
            this.setState({ selectedUser: option?.value })
        } else {
            this.setState({ selectedUser: null })
        }

    }

    render() {
        return (
            <Modal className="cw-custom-modal" isOpen={this.props.show} toggle={this.props.onClose} size={this.props.size || 'md'}>

                <ModalBody >
                    <div className="assign-coordinator">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>
                        <div className="header-text text-center">
                            <span>{this.state.title}</span>
                        </div>
                        <div className='row pt-5'>
                            <div className='col-2'></div>
                            <div className='col-8'>
                                <Dropdown
                                    key="users"
                                    placeholder='Select from the list'
                                    options={this.state.existingUsersDropdown}
                                    onSelect={(option) => this.onSelectUser(option)}
                                    text="title"
                                    style={{ background: "#F6F7F5" }}
                                    invalid={this.state.isSubmit && !this.state.selectedUser}
                                />
                            </div>
                            <div className='col-2 close-icon-wrapper'>
                                <img className="custom-close-icon cursor-pointer" onClick={this.addNewContact} src={getImageSource(ImageConstants.ADD)} />
                            </div>
                        </div>
                        <div className="text-center pt-5">
                            {this.state.selectedUser ?
                                <button className="cw-button-primary" onClick={() => this.onSave()}>
                                    ASSIGN
                                </button>
                                :
                                <button className="cw-button-disabled" >
                                    ASSIGN
                                </button>
                            }
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default AssignCoordinator;